import { useTranslation } from 'react-i18next';
import { Button, Callout } from '@up2d8/ui';
import { problemKind } from './problem-text';
import { useProblemText } from './use-problem-text';

/**
 * Wat er staat als een lijst niet opgehaald kon worden (Extra 2, punt 14).
 *
 * **Niet de lege toestand.** Dat is wat er stond: een mislukte aanroep en een lege tabel zagen er
 * precies hetzelfde uit, en dan denkt een beheerder dat er geen medewerkers zijn terwijl de
 * server er even niet was. "Er is nog niets" en "we weten het niet" zijn twee verschillende
 * dingen, en alleen het tweede heeft een knop nodig.
 */
export function ListError({ onRetry, error }: { onRetry: () => void; error?: unknown }) {
  const { t } = useTranslation();
  const text = useProblemText();
  // Een ontbrekend recht los je niet op door opnieuw te proberen (FBK-2).
  const denied = problemKind(error) === 'denied';

  return (
    <Callout
      tone="danger"
      data-testid="list-error"
      action={
        denied ? undefined : (
          <Button size="sm" variant="secondary" onClick={onRetry}>
            {t('common.retry')}
          </Button>
        )
      }
    >
      {denied ? text(error, '') : t('errors.listFailed')}
    </Callout>
  );
}
